import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { TagCatalogApi, TagCatalogComponent } from "src/app/components/tag-catalog/tag-catalog.component";
import { ActivitySection } from "src/app/constants/activity-log";
import { ActivityLogService } from "src/app/services/activity-log.service";
import { ConfigService } from "src/app/services/config.service";

/** Admin ▸ Tags ▸ Aufgaben - tenant-wide catalog of task tags (#4808). */
@Component({
  selector: "app-config-task-tags",
  imports: [TagCatalogComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<app-tag-catalog [api]="api" [heading]="heading" [description]="description"></app-tag-catalog>`,
})
export class ConfigTaskTagsPageComponent implements OnInit {
  readonly heading = $localize`:@@taskTagsTitle:Task Tags`;
  readonly description = $localize`:@@taskTagsDescription:Define tags to categorise tasks.`;

  readonly api: TagCatalogApi = {
    load: async () => {
      const result = await this.configService.getTaskTags();
      return { ...result, tags: result.taskTags };
    },
    save: (id, name) => this.configService.writeTaskTag({ id, name }),
    remove: (tag) => this.configService.deleteTaskTag(tag.id),
  };

  constructor(private configService: ConfigService, private activityLog: ActivityLogService) {}

  ngOnInit(): void {
    this.activityLog.logView({ Section: ActivitySection.CONFIG_TAGS });
  }
}
